if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      if (document.querySelectorAll(".SoldOut").length > 0) {
        
        let productStickyBarWrapMain = document.querySelector(".product_sticky_bar_wrap_main");
let productStickyBarWrapMainHeight = 0;

if (productStickyBarWrapMain) {
  productStickyBarWrapMainHeight = productStickyBarWrapMain.offsetHeight;
}

        
        const idField = this.form.querySelector('[name=id]');
        let customjsaddtocarterror = document.querySelector("variant-radios");
        
        if (!idField || idField.value.trim() === '') {
            document.querySelectorAll(".SoldOut").forEach(element => {
                element.innerHTML = 'Please select a size.';
            });
            if (customjsaddtocarterror) {
                window.scroll({
                    top: customjsaddtocarterror.offsetTop-productStickyBarWrapMain,
                    behavior: 'smooth'
                });
            }
            return;
        }
    }
    
    
      this.handleErrorMessage();
        this.submitButton.setAttribute('aria-disabled', true);
        if (document.querySelectorAll(".StickyAddToCart").length > 0) {
          const stickyElements = document.querySelectorAll(".StickyAddToCart");
          stickyElements.forEach(element => {
          element.classList.add('loading');
          });
        }

        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
        
        if (document.querySelectorAll(".loading-overlay__spinnerAddtocart").length > 0) {
          const spinnerAddToCart = document.querySelectorAll(".loading-overlay__spinnerAddtocart");
          console.log("Spinner element found");
          spinnerAddToCart.forEach(spinner => {
            spinner.classList.remove('hidden');
          });
        } else {
          console.log("Spinner element not found");
        }
        
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (document.querySelectorAll(".StickyAddToCart").length > 0) {
            const stickyElements = document.querySelectorAll(".StickyAddToCart");
            stickyElements.forEach(element => {
            element.classList.remove('loading');
            });
          }
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          if (document.querySelectorAll(".loading-overlay__spinnerAddtocart").length > 0) {
            const spinnerAddToCart = document.querySelectorAll(".loading-overlay__spinnerAddtocart");
            console.log("Spinner element found");
            spinnerAddToCart.forEach(spinner => {
              spinner.classList.add('hidden');
            });
          } else {
            console.log("Spinner element not found");
          }
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
